import { showMessageModal } from '~/clientUtils/showMessageModal';
import { ERROR_MESSAGE_INFO, ERROR_MESSAGE_TITLE, REGION_FIELD_DATA } from '~/consts/generalSettings';
import { getStore } from '~/mobx/AppStore';

export const showRegionErrorModal = () => {
    const { generalSettingsStore } = getStore();
    const { regionNameError, regionExtraVoteQuantityError } = generalSettingsStore;
    const fieldName = REGION_FIELD_DATA.regionName;
    const fieldExtraVoteQuantity = REGION_FIELD_DATA.regionExtraVoteQuantity;

    const errorMessageContent = (
        <div className="items-center flex flex-col">
            <div>{ERROR_MESSAGE_TITLE}</div>
            {regionNameError && <div>{fieldName.label}</div>}
            {regionExtraVoteQuantityError && <div>{fieldExtraVoteQuantity.label}</div>}
            <div>{ERROR_MESSAGE_INFO}</div>
        </div>
    );
    showMessageModal('error', errorMessageContent);
};
